import { render, staticRenderFns } from "./shortvideosub.vue?vue&type=template&id=35434d67&scoped=true"
import script from "./shortvideosub.vue?vue&type=script&lang=js"
export * from "./shortvideosub.vue?vue&type=script&lang=js"
import style0 from "./shortvideosub.vue?vue&type=style&index=0&id=35434d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35434d67",
  null
  
)

export default component.exports